<template>
  <v-img contain :src="error ? noImageUrl : src" @error="error = true" />
</template>

<script>
// 画像読込失敗時(404)には noimage 画像表示
export default {
  name: "ImgWrapper",
  components: {},
  props: {
    src: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    error: false,
    noImageUrl: require("@/assets/noimage.png"),
  }),
};
</script>
